var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aside',{staticClass:"main-content"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"nest-contents"},[_c('h2',[_vm._v("入力されたメールアドレス宛てにメールを送信しました")]),_c('p',[_vm._v("メールをご確認のうえ、"+_vm._s(_vm.type)+"を完了してください。")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }